
import React, {FC, useState} from 'react';
import {Colors} from 'templates/reports/Section/ScanImages/useColors';
import {Images} from 'templates/reports/Section/ScanImages/useImages/query';
import Selector from 'templates/reports/Section/Snapshot/Selector';

import Selected from './Selected';

import * as snaps from 'templates/reports/Section/Snapshot/styles.module.scss';

type ImageDetailsProps = {
	images: Images[]
	colors: Colors
}

const ImageDetails: FC<ImageDetailsProps> = ({images, colors}) => {
	const [index, setIndex] = useState(0);
	const selected = images[index];
	return (
		<>
			<div className={snaps.header}>
				<h2>Image breakdown by scan</h2>
				<Selector
					results={images}
					onSelect={setIndex}
				/>
			</div>
			<p>
				Select a scan to see its composite x-ray image and
				how it breaks down into fat tissue, lean tissue, and bone.
			</p>
			<Selected selected={selected} colors={colors} />
		</>
	);
};

export default ImageDetails;
